<template>
  <span class="grey--text">
    {{ selectModel(modelValue, dataSelectorKey) | time }} 
  </span>
</template>
<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import ModelVue from "../../ModelVue";

@Component({
  components: {},
})
export default class FCellTime extends ModelVue {
  @Prop()
  dataSelectorKey: string;
}
</script>
